import Request from 'api/request';
import qs from 'qs';

const replacePathParams = (path, params) => {
  return path.replace(/:(\w+)/g, (_, key) => params[key] || `:${key}`);
};

export const DataProvider = () => {
  return {
    getList: ({ resource, pagination, filters, sorters, meta }) => {
      const { apiPrefix, params, ...config } = meta;

      // TODO: Create Generate Filters
      // TODO: Create Generate Sorters
      // TODO: Create Generate Pagination

      const query = qs.stringify(
        Object.fromEntries(
          Object.entries({
            ...filters,
            ...pagination,
            ...sorters,
          }).filter(([_, value]) => value != null) // Remove null/undefined values
        ),
        {
          encodeValuesOnly: true, // Encode only the values
          indices: false, // Serialize arrays without indices (e.g., key=value1&key=value2)
        }
      );
      return Request.call({
        url: `${replacePathParams(resource, params)}${query ? `?${query}` : ''}`,
        method: 'GET',
        apiPrefix,
        // params: {
        //   ...pagination,
        //   ...sorters,
        // },
        ...config,
      });
    },
    getMany: () => {},
    create: ({ resource, variables, meta }) => {
      const { apiPrefix, params, ...config } = meta;
      return Request.call({
        url: replacePathParams(resource, params),
        method: 'POST',
        apiPrefix,
        data: variables,
        ...config,
      });
    },
    update: ({ resource, id, variables, meta }) => {
      const { apiPrefix, params, ...config } = meta;
      return Request.call({
        url: replacePathParams(`${resource}/:id`, {
          ...params,
          id,
        }),
        method: 'PUT',
        apiPrefix,
        data: variables,
        ...config,
      });
    },
    getOne: ({ resource, id, meta }) => {
      const { apiPrefix, params, ...config } = meta;
      return Request.call({
        url: replacePathParams(`${resource}/:id`, {
          ...params,
          id,
        }),
        method: 'GET',
        apiPrefix,
        ...config,
      });
    },
    download: ({ resource, pagination, filters, sorters, meta }) => {
      const { apiPrefix, params, ...config } = meta;
      return Request.call({
        url: replacePathParams(resource, params),
        method: 'GET',
        apiPrefix,
        params: {
          ...pagination,
          ...filters,
          ...sorters,
        },
        ...config,
      });
    },
  };
};
